/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { datadogLogs } from '@datadog/browser-logs';

interface LineItem {
  quantity: number,
  unitPrice: string,
  SKU: string,
  productName: string,
}

interface PurchaseEventData {
  couponCode: string;
  email: string;
  planCode: string | null;
  subscriptionUuid: string;
  total: string;
  userId: string;
  lineItems: LineItem[],
}

// always set trackReferralConversion to true after registration
// used by talkable for purchase & overall revenue tracking
const TRACKING_REFERRAL_CONVERSION = 1;

const mapPlanCodeToPlanId = (planCode: string): number => {
    type MappingType = {
      [key: string]: number;
    };
    const mapping: MappingType = {
      fffvip: 1,
      fffvipa: 2,
    };
    return mapping[planCode];
};

export const firePurchaseEvent = (
  event: string,
  loggerMessage: string,
  purchaseData: PurchaseEventData,
) => {
  const {
    couponCode,
    email,
    planCode,
    subscriptionUuid,
    total,
    userId,
    lineItems,
  } = purchaseData;

  const purchaseEvent = {
    event,
    orderToken: '', // intentionally blank
    userID: userId,
    orderID: userId,
    invoiceID: subscriptionUuid,
    subscriptionUUID: subscriptionUuid,
    planCode,
    planId: planCode ? mapPlanCodeToPlanId(planCode) : '',
    total,
    customerEmail: email,
    revAmount: total,
    discountCode: couponCode,
    trackReferralConversion: TRACKING_REFERRAL_CONVERSION,
    line_items: lineItems,
  };

  if (!window?.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push(purchaseEvent);
  datadogLogs.logger.info(loggerMessage, purchaseEvent);
};
